import { createActions } from 'redux-actions';

export default createActions(
  {
    RESET: () => ({}),
    LOAD: (robotId, mission) => ({ robotId, mission }),
    UNLOAD: (robotId) => ({ robotId }),
  },
  { prefix: 'MISSIONS' }
);
